export const dataTableConfig = {
  pageSizeDefault: 10,
  density: 'compact',
};
